import axios from "axios";

const endpoint = "owner/doctor";
export default {
  async fetchConsultants({ commit, state }) {
    let response;
    try {
      response = await axios.get(state.next_consultants_url);
      commit("SET_SUCCESS", true);
      if (state.shouldAppend) {
        commit("SET_CONSULTANTS", [
          ...state.consultants,
          ...response.data.data,
        ]);
      } else {
        commit("SET_CONSULTANTS", response.data.data);
      }
      commit("SET_NEXT_CONSULTANTS_URL", response.data.links.next);
      commit("SET_SHOULD_APPEND", true);
    } catch (e) {
      commit("SET_NEXT_CONSULTANTS_URL", null);
      commit("SET_ERROR_MESSAGE", e.response.data.message);
      commit("SET_ERRORS", e.response.data.errors);
    }
  },

  resetPage({ commit }, { keywords, endPointUrl }) {
    commit("SET_NEXT_CONSULTANTS_URL", `${endPointUrl}?keywords=${keywords}`);
    commit("SET_CONSULTANTS", []);
    commit("SET_SHOULD_APPEND", false);
  },

  async fetchConsultantInfo(context, id) {
    return (await axios.get(`${endpoint}/show/${id}`)).data.data;
  },

  async fetchConsultantRequestInfo(context, id) {
    return (await axios.get(`owner/doctor-request/${id}`)).data.data;
  },
};
